


const initialState={
    headerMenuRouterPath:'',
}


const heareMenuRoutePathReducer=(state=initialState,action={})=>{
    return Object.assign({},state,{
        headerMenuRouterPath:action.path,
    });
}

export default heareMenuRoutePathReducer;

